export default "__VITE_ASSET__DGEegjlX__"